export default "__VITE_ASSET__Cjq0m9rv__"